import { usePromisedRequest } from "../../Common/request";
import { resolveNoContent, resolveWithBody } from "../Utils/utils";
import { Competitor } from "../../Common/Competitors/types";

export const DividingStrategyEnum = {
    Academy: "academy",
    RegistrationDate: "registrationDate",
} as const;

export type DividingStrategy = (typeof DividingStrategyEnum)[keyof typeof DividingStrategyEnum];

export type DivideCategoryRequest = {
    eventId: number;
    parameterId: number;
    desiredSizeOfSubCategories: number;
    dividingStrategy: DividingStrategy;
};

export type DividedCategoryPreview = {
    registeredCompetitors: Array<Competitor[]>;
    totalCompetitors: number;
    blockedByBracket: boolean;
};

export default {
    previewDividedCategory(request: DivideCategoryRequest): Promise<DividedCategoryPreview> {
        return usePromisedRequest<DividedCategoryPreview>({
            url: `/api/events/${request.eventId}/categories/divide/preview`,
            json: request,
            method: "post",
        }).then(resolveWithBody());
    },
    confirmDividedCategory(request: DivideCategoryRequest): Promise<void> {
        return usePromisedRequest<void>({
            url: `/api/events/${request.eventId}/categories/divide/confirm`,
            json: request,
            method: "post",
        }).then(resolveNoContent());
    },
};
